<template>
	<div class="prog_reg-body theme-light">
		<!-- <div class="container">
			<div class="row">
				<dropdown-payment
					v-if="!isPaymentResult"
					ref="dropdownPayment"
					:form-data="formData"
					:event-payment="event"
					@blur="onBlur"
				/>

			</div>
		</div> -->
		<div v-if="!formData.reverse_step_4 || isShowDocBlock" class="container">
			<div class="row">
				<div class="col-12 col-md-12">
					<div class="title mb-3">
						Загрузка документов
					</div>
					<div class="description">
						<p>Для заключения договора на обучение нам понадобятся данные и копии документов студентов</p>
						<p>Размер файла не должен превышать 2MB</p>
					</div>
				</div>
			</div>
		</div>

		<div v-if="!formData.reverse_step_4" class="container">
			<div class="row">
				<div class="col-12 col-md-12 mb-4">
					<div class="disclaimer alert alert alert-danger mb-2 text-center">
						<span class="alert-circle-red d-flex align-self-start">Заполнив документы сейчас у вас есть возможность снизить риски связанные с оформлением и доступом к курсу в дальнейшем.</span>
						<button
							class="btn btn-link p-0"
							@click.prevent="$bvModal.show('documents-list')"
						>
							Читать пункты договора
						</button>
					</div>
				</div>
			</div>
		</div>

		<div v-if="formData.reverse_step_4 && !isShowDocBlock" class="container">
			<div class="row">
				<div class="col-12 col-md-12 mb-2">
					<div class="pt-4 pb-2 disclaimer alert text-center theme-darkgray">
						<h3>Успешная регистрация</h3>
						<p>Спасибо! Ваша регистрация принята.  Обращаем ваше внимание, что для получения подтверждения участия и возможности оплаты, необходимо предоставить дополнительную информацию о вас</p>
					</div>
				</div>
			</div>
		</div>

		<document-info-message
			v-if="!formData.disable_step_4
				&& !isShowDocBlock
				&& formData.reverse_step_4"
			:form-data="formData"
			@show-doc="showDocBloc"
		/>

		<div
			v-if="!getIsRegistrant(formData.id) && (!formData.reverse_step_4
				|| isShowDocBlock)"
			class="person-choise"
		>
			<div class="container">
				<b-card no-body class="mb-2">
					<b-card-header header-tag="header" class="p-0" role="tab">
						<div
							class="accordeon-participant-pane"
							:class="{
								ready: isValidSelf === true,
								'not-ready': isValidSelf === false
							}"
						>
							{{ getFullName(formData.id) }} - {{ getRoleName(formData.id) }}
						</div>
					</b-card-header>
					<div role="tabpanel">
						<b-card-body class="pt-0">
							<b-form>
								<div class="row">
									<base-field
										v-for="field in formData.fields[getStep(formData.id)]"
										:key="field.field_id"
										ref="baseFields"
										:only-type="onlyUploadExplicit"
										:field="field"
										:person-number="1"
										:form-data="formData"
										@blur="onBlur"
									/>
								</div>

								<div>
									<base-field
										v-for="field in formData.fields[getStep(formData.id)]"
										:key="field.field_id"
										ref="baseFields"
										:only-type="onlyUploadAny"
										:field="field"
										:person-number="1"
										:form-data="formData"
										@blur="onBlur"
									/>
								</div>
							</b-form>
						</b-card-body>
					</div>
				</b-card>
			</div>
		</div>

		<div v-if="formData.id && getAdditionalPersonsCount(formData.id) > 0">
			<step4-person-field-group
				v-for="n in getAdditionalPersonsCount(formData.id)"
				:key="n"
				ref="personGroups"
				:person-number="n + 1"
				:form-data="formData"
				:current-step="currentStep"
			/>
		</div>

		<b-modal v-if="!formData.reverse_step_4" id="documents-list" size="lg">
			<div class="d-block">
				<p>
					2.2.1. Для приема (зачисления) на обучение в Школу, зачисления на Программу и формирования личного дела Слушателя в соответствии с требованиями законодательства Российской Федерации Слушатель предоставляет Школе следующие документы:
				</p>
				<p>
					<ul>
						<li>- заявление о приеме на программу (электронная регистрация на Сайте);</li>
						<li>- документ, удостоверяющий личность (скан-, фотокопия разворота с ФИО);</li>
						<li>- документ о среднем профессиональном или высшем образовании (скан-, фотокопия) или документ, выданный в иностранном государстве и признаваемый эквивалентным российскому документу о среднем профессиональном или высшем образовании на основании международного соглашения Российской Федерации с государством, в котором выдан такой документ (ранее и далее документ об образовании);</li>
						<li>при получении Слушателем высшего или среднего профессионального образования на момент зачисления на Программу - справка из учебного заведения, подтверждающая получение Слушателем высшего или среднего профессионального образования на момент зачисления на Программу (копия). Копия документа об образовании предоставляется Слушателем Школы по факту его получения;</li>
						<li>- документ, подтверждающий смену фамилии (при необходимости).</li>
					</ul>
				</p>
				<p>
					2.2.2. Отсутствие документов, указанных в пункте 2.2.1., после начала Программы является основанием для расторжения Договора Школой в одностороннем внесудебном порядке. При этом в соответствии с Федеральным законом «Об образовании в Российской Федерации» удостоверение о повышении квалификации или диплом о профессиональной переподготовке не выдаётся, по запросу Слушателя ему может быть выдана справка об обучении или периоде обучения с указанием количества прослушанных часов.
				</p>
			</div>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="rounded-pill" variant="primary" @click="ok()">
					Закрыть
				</b-button>
			</template>
		</b-modal>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseField from '~/components/checkout/CheckoutBaseField.vue';
import Step4PersonFieldGroup from '@/components/checkout/Step4PersonFieldGroup.vue';
import { TYPE_TO_FIELD_MAP } from '@/components/checkout/fieldTypeDictionary';
import checkoutFormStep from '@/mixins/checkoutFormStep';
import DocumentInfoMessage from '@/components/checkout/DocumentInfoMessage.vue';
import DropdownPayment from './fields/DropdownPayment.vue';

export default {
	name: 'CheckoutStep4', // Есть завязка на это название
	components: {
		BaseField,
		Step4PersonFieldGroup,
		DocumentInfoMessage,
		DropdownPayment,
	},
	mixins: [checkoutFormStep],
	props: {
		formData: { type: Object, required: true },
		isPaymentResult: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			onlyUploadExplicit: TYPE_TO_FIELD_MAP[6],
			onlyUploadAny: TYPE_TO_FIELD_MAP[7],
			isShowDocBlock: false,
			paymentProvider: null,
		};
	},
	computed: {
		...mapGetters({
			getAdditionalPersonsCount: 'checkout/getAdditionalPersonsCount',
			getStep: 'checkout/getStep',
			getFullName: 'checkout/getFullName',
			getRoleName: 'checkout/getRoleName',
		}),
	},
	methods: {
		showDocBloc() {
			this.isShowDocBlock = !this.isShowDocBlock;
		},
	},
};
</script>

<style lang="scss">
	@import "~/assets/styles/components/home/prog-registration";

	.alert-circle-red {
		&::before {
			width: 1.3rem;
			height: 1.3rem;
			margin-right: 1rem;
			content: url("data:image/svg+xml;charset=UTF-8, <svg width='1rem' height='1rem' viewBox='0 0 16 16' class='bi bi-exclamation-circle' fill='#721c24' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' d='M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z'/><path d='M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z'/></svg>");
			background-size: 1.3rem 1.3rem;
		}
	}
</style>
